export enum Mode {
    PROMOTION = 'promotion',
    FACTURATION = 'facturation'
}